import { isDevServer, serverForImages } from '../config'

export const imageLoaderForStaticImages = ({ src }: { src: string }) => {
  return src
}

export const imageLoader = ({ src }: { src: string }) => {
  return serverForImages + src
}

export const fetcher = (url: string): Promise<any> => {
  const options: RequestInit = {
    method: 'GET',
  }

  return fetch(url, options).then((r) => r.json())
}

export const parseYoutubeEmbeddedId = (fileUrl: string) => {
  var regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]{11})/;
  var match = fileUrl.match(regExp);
  if (match && match[2].length == 11) {
    return match[2].toString();
  }
  return "";
}